import { defineComponent as g, useCssModule as x, ref as u, provide as k, computed as l, onMounted as b, createElementBlock as A, openBlock as C, normalizeClass as D, unref as h, renderSlot as B } from "vue";
import { debounce as _ } from "../../utils/debounce.mjs";
import E from "../../utils/propValidator.mjs";
import i from "../../mixins/breakpoints.mjs";
import { unwrappedKey as G } from "../../types/symbols.mjs";
const I = "cdr-accordion-group", U = /* @__PURE__ */ g({
  name: "CdrAccordionGroup",
  __name: "CdrAccordionGroup",
  props: {
    /**
     * A prop that will present accordion content as unwrapped. All content is expanded at the provided breakpoints.
     * @values @xs, @sm, @md, @lg, true
     */
    unwrap: {
      type: [String, Boolean],
      default: !1,
      validator: (o) => typeof o == "string" ? E(o, ["@xs", "@sm", "@md", "@lg"], !1) : typeof o == "boolean"
    }
  },
  setup(o) {
    const t = o, f = x(), a = u(0), c = u(), p = u(null), s = u(!!t.unwrap);
    k(G, s);
    const r = l(() => c.value ? [...c.value] : []), v = l(() => {
      var n;
      const e = a.value + 1;
      return e >= ((n = r.value) == null ? void 0 : n.length) ? 0 : e;
    }), m = l(() => {
      const e = a.value - 1;
      return e <= -1 ? r.value.length - 1 : e;
    }), w = (e) => {
      var d;
      if (a.value === -1) return;
      const {
        key: n
      } = e;
      switch (n) {
        case "Home":
          e.preventDefault(), (d = r.value[0]) == null || d.focus();
          break;
        case "End":
          e.preventDefault(), r.value[r.value.length - 1].focus();
          break;
        case "ArrowDown":
        case "Down":
          e.preventDefault(), r.value[v.value].focus();
          break;
        case "ArrowUp":
        case "Up":
          e.preventDefault(), r.value[m.value].focus();
          break;
      }
    }, y = (e) => {
      a.value = Array.prototype.indexOf.call(r.value, e.target);
    };
    return b(() => {
      var e;
      c.value = (e = p.value) == null ? void 0 : e.querySelectorAll(".js-cdr-accordion-button"), typeof t.unwrap == "string" && (s.value = t.unwrap.indexOf(i()) !== -1, window.addEventListener("resize", _(() => {
        s.value = t.unwrap.indexOf(i()) !== -1;
      }, 300)));
    }), (e, n) => (C(), A("div", {
      class: D(h(f)[I]),
      ref_key: "accordionGroupEl",
      ref: p,
      onFocusin: y,
      onKeydown: w
    }, [B(e.$slots, "default")], 34));
  }
});
export {
  U as default
};
